import { FilterMatchMode } from "primeng/api";

export const DATEFORMAT_DATATABLE = 'yyyy-LL-dd';
export const DATEFORMAT_DATATABLE_TOOLTIP = 'yyyy-LL-dd HH:mm:ss';
export const DATEFORMAT_DATATABLE_TIME = 'HH:mm:ss';

export const LOCALSTORAGE_LOGIN_REDIRECT_KEY = 'vatrisk-loginRedirect';

export const DEFAULT_PAGESIZES = [10, 25, 50];

export type Column = {
    field: string;
    header: string;
    type: "text" | "numeric" | "date" | "enum";
};

export const ERROR_CODES = {
    concurrentLogin: 'CONCURRENT_LOGIN',
};

export const API_BASE_URI = ''

export const COOKIE_KEYS = {
    concurrentLogin: 'ConcurrentLogin',
};

export const FILTER_MATCH_MODES: {
    text: string[];
    numeric: string[];
    date: string[];
} = {
    text: [
        FilterMatchMode.CONTAINS,
        FilterMatchMode.EQUALS,
        FilterMatchMode.STARTS_WITH,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.NOT_CONTAINS,
        // FilterMatchMode.ENDS_WITH,
    ],
    numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        FilterMatchMode.DATE_IS,
        // FilterMatchMode.DATE_IS_NOT,
        FilterMatchMode.DATE_BEFORE,
        FilterMatchMode.DATE_AFTER
    ]
};

export const HEADER_KEYS = {
    xsrfRequestToken: 'XSRF-TOKEN',
    xsrfToken: 'X-XSRF-TOKEN',
};

export const COOKIE_LANG_KEY: string = '.PwC.ByX.Auditor.Culture';
export const COOKIE_LANG_VALUES: { [key: string]: string } = {
    'en-US': 'c=en-US|uic=en-US',
    'hu-HU': 'c=hu-HU|uic=hu-HU'
};

export const REGEX: { [key: string]: RegExp; } = {
    noSpecial: /^[^<>*!]+$/
};

export const APP_LANGS = Object.keys(COOKIE_LANG_VALUES);
